import React from 'react';

import { Button } from '@components/common';

import styles from './DescriptionsModal.module.scss';

interface IDescriptionsModalProps {
	value: string;
	closeModal: () => void;
}

const DescriptionsModal = ({
	value,
	closeModal,
}: IDescriptionsModalProps) => {
	return (
		<div className={styles.container}>
			<div className={styles.text}>
				{value}
			</div>
			<Button
				onClick={closeModal}
				text='Close'
			/>
		</div>
	);
};

export default DescriptionsModal;
